/**
 * @flow
 * @relayHash 07090113e9235976bdba3defc04fc950
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CSMoneyStatementList_viewer$ref = any;
export type CSMoneyStatementListQueryVariables = {|
  first?: ?number,
  offset?: ?number,
  search?: ?string,
  processedAt_Isnull?: ?boolean,
|};
export type CSMoneyStatementListQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: CSMoneyStatementList_viewer$ref
  |}
|};
export type CSMoneyStatementListQuery = {|
  variables: CSMoneyStatementListQueryVariables,
  response: CSMoneyStatementListQueryResponse,
|};
*/


/*
query CSMoneyStatementListQuery(
  $first: Int
  $offset: Int
  $search: String
  $processedAt_Isnull: Boolean
) {
  viewer {
    ...CSMoneyStatementList_viewer_3llZbG
    id
  }
}

fragment CSMoneyStatementList_viewer_3llZbG on Query {
  clearstreamMoneyStatements(first: $first, offset: $offset, orderBy: "-id", search: $search, processedAt_Isnull: $processedAt_Isnull) {
    edges {
      node {
        id
        amount: settledAmount
        createdAt
        updatedAt
        settledAmount
        currency
        processedAt
        processedBy {
          fullName
          id
        }
        brokeractivityPtr {
          id
          brokeractivitytransactionSet {
            edges {
              node {
                id
                createdAt
              }
            }
          }
        }
        transactionIndicator
        yourReference
        internalReference
        isin
        commonCode
        notes {
          id
        }
      }
    }
    count
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "processedAt_Isnull",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v2 = {
  "kind": "Variable",
  "name": "offset",
  "variableName": "offset"
},
v3 = {
  "kind": "Variable",
  "name": "processedAt_Isnull",
  "variableName": "processedAt_Isnull"
},
v4 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CSMoneyStatementListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "CSMoneyStatementList_viewer",
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CSMoneyStatementListQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "clearstreamMoneyStatements",
            "storageKey": null,
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": "-id"
              },
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "concreteType": "CSMoneyStatementNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CSMoneyStatementNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CSMoneyStatementNode",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": "amount",
                        "name": "settledAmount",
                        "args": null,
                        "storageKey": null
                      },
                      (v6/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "updatedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "settledAmount",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "currency",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "processedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "processedBy",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "UserNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "fullName",
                            "args": null,
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokeractivityPtr",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerActivityNode",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "brokeractivitytransactionSet",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrokerActivityTransactionNodeConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BrokerActivityTransactionNodeEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BrokerActivityTransactionNode",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v6/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "transactionIndicator",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "yourReference",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "internalReference",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isin",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "commonCode",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "notes",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "NotesNode",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "count",
                "args": null,
                "storageKey": null
              }
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "CSMoneyStatementListQuery",
    "id": null,
    "text": "query CSMoneyStatementListQuery(\n  $first: Int\n  $offset: Int\n  $search: String\n  $processedAt_Isnull: Boolean\n) {\n  viewer {\n    ...CSMoneyStatementList_viewer_3llZbG\n    id\n  }\n}\n\nfragment CSMoneyStatementList_viewer_3llZbG on Query {\n  clearstreamMoneyStatements(first: $first, offset: $offset, orderBy: \"-id\", search: $search, processedAt_Isnull: $processedAt_Isnull) {\n    edges {\n      node {\n        id\n        amount: settledAmount\n        createdAt\n        updatedAt\n        settledAmount\n        currency\n        processedAt\n        processedBy {\n          fullName\n          id\n        }\n        brokeractivityPtr {\n          id\n          brokeractivitytransactionSet {\n            edges {\n              node {\n                id\n                createdAt\n              }\n            }\n          }\n        }\n        transactionIndicator\n        yourReference\n        internalReference\n        isin\n        commonCode\n        notes {\n          id\n        }\n      }\n    }\n    count\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c095cf1ba83507ff62a61ecd3c1d480e';
module.exports = node;
